export default __webpack_public_path__ + "static/media/gettyimages-1208483325-2048x2048.9a197e28.jpg";